module.exports = {
      id: "webatvantage-usage",
      viewBox: "0 0 106 20",
      url: __webpack_public_path__ + "img/icons.209f7259.svg#webatvantage-usage",
      toString: function () {
        return this.url;
      }
    }